import { ConstraintValidator, ConstraintValue } from '../index';
import useConstraintValidatorHelper from './constaintValidatorHelper';

export interface DomainConstraintValidator extends ConstraintValidator<string> {
}

export default function useDomainConstraintValidator(): DomainConstraintValidator {

  const helperFactory = useConstraintValidatorHelper<number>();

  const validate = (
    object: Record<string, any>,
    fieldName: string,
    constraintConfiguration: ConstraintValue<string>,
  ): boolean => {

    const re = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/i;

    const helper = helperFactory.createHelper(
      object,
      fieldName,
      constraintConfiguration,
    );
    const value = helper.getValue();

    if (helper.hasValue()) {
      return re.test(value);
    } else {
      return true;
    }
  };

  const getErrorMessage = (config: ConstraintValue<string>) => {
    return (typeof config === 'object' && config.message)
      || 'The field value should be a valid domain name';
  };

  return {
    getName: () => 'domain',
    validate,
    getErrorMessage,
  };
}
